export interface CanonicalBankMoneyOutFields {
  totalDebits?: unknown;
  statedDebits?: unknown;
  checksAmount?: unknown;
  serviceFees?: unknown;
  moneyOutOverride?: unknown;
  dealerCorrectedDebits?: unknown;
  dealerVerifiedAt?: unknown;
}

export interface CanonicalBankMoneyOutResolution {
  value: number;
  calculationDependencies: string[];
}

export function parseStrictBankMoneyValue(value: unknown): number | null {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed || !/^[+-]?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(trimmed)) return null;
  const parsed = Number(trimmed.replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
}

export function resolveCanonicalBankMoneyOut(
  statement: CanonicalBankMoneyOutFields,
): CanonicalBankMoneyOutResolution | null {
  if (statement.dealerVerifiedAt) {
    const corrected = parseStrictBankMoneyValue(statement.dealerCorrectedDebits);
    return corrected == null
      ? null
      : { value: corrected, calculationDependencies: ["dealerCorrectedDebits"] };
  }

  if (statement.moneyOutOverride != null && statement.moneyOutOverride !== "") {
    const override = parseStrictBankMoneyValue(statement.moneyOutOverride);
    return override == null
      ? null
      : { value: override, calculationDependencies: ["moneyOutOverride"] };
  }

  const debitSource = statement.statedDebits ?? statement.totalDebits;
  const base = parseStrictBankMoneyValue(debitSource);
  if (base == null) return null;
  const checks = statement.checksAmount == null || statement.checksAmount === ""
    ? 0
    : parseStrictBankMoneyValue(statement.checksAmount);
  const fees = statement.serviceFees == null || statement.serviceFees === ""
    ? 0
    : parseStrictBankMoneyValue(statement.serviceFees);
  if (checks == null || fees == null) return null;

  return {
    value: base + checks + fees,
    calculationDependencies: [
      statement.statedDebits == null ? "totalDebits" : "statedDebits",
      "checksAmount",
      "serviceFees",
    ],
  };
}